export default "__VITE_ASSET__5f665383__"